import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import SweetAlert2 from 'react-sweetalert2';
import apiService from './../../Auth/apiService';
import { FaEraser, FaTasks, FaUser, FaUsers } from 'react-icons/fa';
import { useAuth } from './../../Auth/AuthContext';

export default function Organizaciones() {
  const navigate = useNavigate();
  const { token, rol, user } = useAuth();
  const [swalProps, setSwalProps] = useState({});
  const [Cargando, setCargando] = useState(false);
  const [allOrganizaciones, setAllOrganizaciones] = useState([]); // full dataset
  const [organizaciones, setOrganizaciones] = useState([]); // filtered view
  const [filterNombre, setFilterNombre] = useState('');
  const [filterComuna, setFilterComuna] = useState('');
  const [totalRegistros, setTotalRegistros] = useState(0);
  const confirmarEliminarResolverRef = useRef(null);
  const confirmarEliminarDecisionRef = useRef(null);
   
  function handleEdit (row){
    navigate(`/organizaciones/mostrarformulario/${row.id}`);
  };
  function verActividades(row) {
    navigate(`/organizaciones/${row.id}/actividades`);
  };
  function mensajeEliminar(title, text) {
        return new Promise((resolve) => {
            confirmarEliminarResolverRef.current = resolve;
            confirmarEliminarDecisionRef.current = null;
            setSwalProps({
            show: true,
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
              confirmarEliminarDecisionRef.current = true;
              return true;
            },
            });
        });
    }
  async function Eliminar(row) {
    const confirmEliminar = await mensajeEliminar("Eliminar", `¿Está seguro de que desea eliminar a ${row.org_nombre}?`);
      if (!confirmEliminar) {
          return;
      }
      setCargando(true);
      const url = '/organizaciones/eliminarorganizacion';
      const obj = {
          id: row.id,
          usrId: user,
      };
      try {
          const response = await apiService.post(url, obj, token);
          if(response.status === 200){
            await fetchOrganizaciones();
              Mensaje('Eliminar', JSON.stringify(response.data.message));
          }
      } catch (error) {
          if(error.status === 422){
              Mensaje('Eliminar', JSON.stringify(error.response.data.errors));
          }else if(error.status === 409){
              Mensaje('Eliminar', JSON.stringify(error.response.data.message));
          }else{
            Mensaje('Eliminar', error.response?.data?.message ? JSON.stringify(error.response.data.message) : 'Ocurrió un error inesperado.')
          }
      } finally {
          setCargando(false);
      }
  }
  useEffect(() => {
    fetchOrganizaciones();
  }, []);

  // apply simple client-side filters when data or filter inputs change
  useEffect(() => {
    const nombre = String(filterNombre || '').trim().toLowerCase();
    const comuna = String(filterComuna || '').trim().toLowerCase();
    if ((!nombre && !comuna) || !Array.isArray(allOrganizaciones)) {
      setOrganizaciones(allOrganizaciones || []);
      return;
    }
    const filtered = (allOrganizaciones || []).filter((row) => {
      const n = String(row.org_nombre || '').toLowerCase();
      const c = String(row.org_comuna || '').toLowerCase();
      return (nombre ? n.includes(nombre) : true) && (comuna ? c === comuna : true);
    });
    setOrganizaciones(filtered);
  }, [allOrganizaciones, filterNombre, filterComuna]);

  const Mensaje = (title, text) => {
      setSwalProps({
        show: true,
        title: title,
        text: text,
    });
  };
  async function fetchOrganizaciones () {
      setCargando(true);
      try {
        const response = await apiService.get(`/organizaciones/consultar`, token);
        setAllOrganizaciones(response.data.organizaciones || []);
        setOrganizaciones(response.data.organizaciones || []);
        setTotalRegistros(response.data.total || 0);
      } catch (error) {
        if (error.response?.data?.message) {
          Mensaje('Error', error.response.data.message);
        } else {
          console.error(error);
          Mensaje('Error', 'No se pudo cargar las organizaciones');
        }
      } finally {
        setCargando(false);
      }
    };
  const exportToExcel = async () => {
    if (!Array.isArray(organizaciones) || organizaciones.length === 0) {
      Mensaje('Exportar', 'No hay datos para exportar');
      return;
    }
    try {
      const xlsxMod = await import('xlsx');
      const XLSX = xlsxMod?.default ?? xlsxMod;

      const headers = ['Id','Nombre','Correo','Teléfono','Dirección','Comuna'];
      const rows = organizaciones.map(r => [
        r.id ?? '',
        r.org_nombre ?? '',
        r.org_correo ?? '',
        r.org_telefono ?? '',
        r.org_direccion ?? '',
        r.org_comuna ?? ''
      ]);

      const aoa = [headers, ...rows];
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Organizaciones');

      const wbout = await XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `organizaciones_${new Date().toISOString().slice(0,19).replace(/[:T]/g,'-')}.xlsx`;

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
        return;
      }
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      // fallback: notify user
      console.error(err);
      Mensaje('Exportar', 'No se pudo generar el archivo Excel. Asegúrese de tener la dependencia xlsx disponible.');
    }
  };
  return (
        
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Lista organizaciones</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item active">Organizaciones</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section>
              <div className="container-fluid">               
                <section className="content">
                    <div className="container-fluid">
                          {Cargando && <div className="centered">
                            <div><progress value={null} /></div>
                          </div>}
                          
                    </div>
                </section>
                <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-header">
                          <div style={{ float: 'left', fontWeight: 600 }}>
                            {`Total: ${totalRegistros || 0} organizaciones`}
                          </div>
                          <div className="card-tools">
                            <div className="row">
                              <div className="col-md-12">
                                <button
                                    type="button"
                                    className="btn btn-block btn-primary"
                                    style={{
                                        backgroundColor: 'skyblue',
                                        color: 'black', // Font color black
                                        padding: '6px 12px',         // Smaller padding
                                        fontSize: '1rem',            // Smaller font size
                                        borderRadius: '6px',         // Slightly smaller radius
                                        border: 'none',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    onClick={() => navigate(`/organizaciones/mostrarformulario/0`)}
                                >
                                    <FaUser /> Crear organizacion
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-body table-responsive p-0">
                          <table className="table table-bordered table-hover">
                              <thead>
                                  <tr>
                                      <th>Acciones</th>
                                      <th>Nombre</th>
                                      <th>Correo</th>
                                      <th>Teléfono</th>
                                      <th>Dirección</th>
                                      <th>Comuna</th>
                                      <th>Id organizaci&oacute;n</th>
                                  </tr>
                                  <tr>
                                      <th>
                                        <button type="button"
                                          className="btn btn-sm btn-success"
                                          onClick={exportToExcel}
                                        >Exportar Excel</button>
                                      </th>
                                      <th>
                                        <input
                                              type="text"
                                              className="form-control form-control-sm"
                                              placeholder="Filtrar por nombre"
                                              value={filterNombre}
                                              onChange={(e) => setFilterNombre(e.target.value)}
                                          />
                                      </th>
                                      <th></th>
                                      <th />
                                      <th />
                                      <th>
                                          <input
                                              type="text"
                                              className="form-control form-control-sm"
                                              placeholder="Filtrar por comuna"
                                              value={filterComuna}
                                              onChange={(e) => setFilterComuna(e.target.value)}
                                          />
                                      </th>
                                      <th />
                                  </tr>
                              </thead>
                              <tbody>
                                  {(!organizaciones || organizaciones.length === 0) ? (
                                      <tr>
                                          <td colSpan="7" className="text-center">
                                              No hay organizaciones para mostrar
                                          </td>
                                      </tr>
                                  ) : (
                                      organizaciones.map((row, idx) => (
                                          <tr key={row.id || idx}>
                                              <td>
                                                  <div style={{ display: 'flex', gap: 8 }}>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleEdit(row)}
                                                        style={{
                                                            backgroundColor: 'skyblue',
                                                            padding: '10px 14px',
                                                            fontSize: '1.1rem',
                                                            borderRadius: '8px',
                                                            border: 'none',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                        data-tooltip-id='tooltiparriba'
                                                        data-tooltip-content="Ver datos de la organizaci&oacute;n"
                                                    >
                                                        <FaUsers />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => verActividades(row)}
                                                        className="btn"
                                                        style={{
                                                            backgroundColor: '#6c757d',
                                                            color: 'white',
                                                            padding: '10px 12px',
                                                            fontSize: '0.95rem',
                                                            borderRadius: '8px',
                                                            border: 'none',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                        data-tooltip-id='tooltiparriba'
                                                        data-tooltip-content="Ver actividades"
                                                    >
                                                        <FaTasks />
                                                    </button>
                                                    {rol === '2' && 
                                                      <button
                                                          type="button"
                                                          onClick={async () => await Eliminar(row)}
                                                          className="btn"
                                                          style={{
                                                              backgroundColor: '#dc3545',
                                                              color: 'white',
                                                              padding: '10px 12px',
                                                              fontSize: '0.95rem',
                                                              borderRadius: '8px',
                                                              border: 'none',
                                                              display: 'flex',
                                                              alignItems: 'center',
                                                              justifyContent: 'center'
                                                          }}
                                                          data-tooltip-id='tooltiparriba'
                                                          data-tooltip-content="Eliminar organización"
                                                      >
                                                          <FaEraser />
                                                      </button>
                                                    }
                                                  </div>
                                              </td>
                                              <td>{row.org_nombre}</td>
                                              <td>{row.org_correo}</td>
                                              <td>{row.org_telefono}</td>
                                              <td>{row.org_direccion}</td>
                                              <td>{row.org_comuna}</td>
                                              <td>{row.id}</td>                                              
                                          </tr>
                                      ))
                                  )}
                              </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                <SweetAlert2 {...swalProps} 
                  didClose={() => {
                      if (confirmarEliminarResolverRef.current) {
                        confirmarEliminarResolverRef.current(Boolean(confirmarEliminarDecisionRef.current));
                        confirmarEliminarResolverRef.current = null;
                        confirmarEliminarDecisionRef.current = null;
                      }
                      setSwalProps({})
                  }}/>
                <Tooltip id="tooltiparriba" place="right"/>
              </div>
            </section>
        </div>
        
        
    )
  }